// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__3TBa8","text":"Pagination_text__5Bp38","button":"Pagination_button__-6m66"};